// Shared query keys for countries and states
export const queryKeys = {
  roles: ['roles'] as const,
  assignedProjects: (idEmployee: number, endDate: Date) => ['assignedProjects', idEmployee, endDate] as const,
  taskByEmployeeAndProject: (idEmployee: number, idProject: number) => ['taskByEmployeeAndProject', idEmployee, idProject] as const,
  notifications: ['notifications'] as const,
  calendarEvents: (start?: Date, end?: Date, eventType?: string) => ['calendarEvents', start?.toISOString(), end?.toISOString(), eventType] as const,
  calendarEventsSearch: (start?: Date, end?: Date, term?: string, filters?: Array<string>) => ['calendarEventsSearch', start?.toISOString(), end?.toISOString(), term, filters] as const,
  employeeTimeOffRegime: (employeeId: number) => ['employeeTimeOffRegime', employeeId] as const,
  timeOffTypes: (regimeId?: number | null, isHRView?: boolean) => ['timeOffTypes', regimeId, isHRView] as const,
  accounts: (filters?: Record<string, any>) => ['accounts', filters] as const,
  account: (id: number) => ['account', id] as const,
  accountBalance: (accountId: number) => ['accountBalance', accountId] as const,
  accountsSummary: ['accountsSummary'] as const,
  ledgerMovements: (accountId: number, pageNum?: number, pageSize?: number, sort?: string, order?: string, startDate?: string, endDate?: string) => 
    ['ledgerMovements', accountId, pageNum, pageSize, sort, order, startDate, endDate] as const,
}

// Type for query keys
export type QueryType = 'roles' | 'assignedProjects' | 'taskByEmployeeAndProject' | 'notifications' | 'calendarEvents' | 'calendarEventsSearch' | 'employeeTimeOffRegime' | 'timeOffTypes' | 'accounts' | 'account' | 'accountBalance' | 'accountsSummary' | 'ledgerMovements';
/*
api.projectApi.apiVversionProjectGetByEmployeeIdIdGet(idEmployee, "1", endDate)
api.jobsApi.apiVversionTaskGetByEmployeeAndProjectIdEmployeeIdProjectGet(input.idEmployee, idProject, "1")
*/